import { Dispatch, FC, SetStateAction } from "react";

type TabNameTypes = "Общее" | "Безопасность" | "Приватность" | "Уведомления";
type TabValueTypes = "general" | "privacy" | "notifications" | "secure";

interface ITabs {
  name: TabNameTypes;
  value: TabValueTypes;
}

interface TabButtonType {
  tab: ITabs;
  currentTab: ITabs;
  setCurrentTab: Dispatch<SetStateAction<ITabs>>;
}

const TabButton: FC<TabButtonType> = ({ tab, currentTab, setCurrentTab }) => (
  <div
    className={tab.value === currentTab.value ? "card active" : "card"}
    onClick={() => {
      setCurrentTab({ name: tab.name, value: tab.value });
    }}
  >
    {tab.name}
  </div>
);

export type { ITabs, TabButtonType, TabNameTypes, TabValueTypes };

export { TabButton };
